import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export default function ViewLogs() {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const q = query(collection(db, 'logs'), orderBy('timestamp', 'desc'));
        const snapshot = await getDocs(q);
        setLogs(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error('Error fetching logs:', error);
      }
    };

    fetchLogs();
  }, []);

  return (
    <div style={styles.container}>
      <button onClick={() => navigate('/dashboard')} style={styles.backButton}>
        ← Back to Dashboard
      </button>
      <h2 style={styles.title}>📜 Admin Logs</h2>

      {logs.length === 0 ? (
        <p style={styles.placeholder}>No logs found.</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Action</th>
              <th style={styles.th}>User</th>
              <th style={styles.th}>Admin</th>
              <th style={styles.th}>Timestamp</th>
              <th style={styles.th}>Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id} style={styles.row}>
                <td style={styles.td}>{log.action || '—'}</td>
                <td style={styles.td}>{log.userEmail || '—'}</td>
                <td style={styles.td}>{log.adminEmail || '—'}</td>
                <td style={styles.td}>
                  {log.timestamp?.seconds
                    ? new Date(log.timestamp.seconds * 1000).toLocaleString()
                    : '—'}
                </td>
                <td style={styles.td}>{log.details || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    fontFamily: 'system-ui, sans-serif',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
  },
  backButton: {
    backgroundColor: '#eeeeee',
    border: '1px solid #ccc',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 500,
    marginBottom: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#065f46',
    marginBottom: '1rem',
  },
  placeholder: {
    fontStyle: 'italic',
    color: '#777',
    marginTop: '2rem',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#fff',
  },
  th: {
    textAlign: 'left',
    padding: '12px',
    backgroundColor: '#e0f2f1',
    fontWeight: '600',
    fontSize: '0.875rem',
    color: '#000',
  },
  td: {
    padding: '12px',
    fontSize: '0.875rem',
    color: '#333',
  },
  row: {
    borderBottom: '1px solid #eee',
  },
};
